const disabilityTypes = [
  { value: 'wheelchair', name: 'osoba na wózku' },
  { value: 'walk_diffuculty', name: 'trudności z chodzeniem' },
  { value: 'visually_impaired', name: 'osoba niedowidząca' },
  { value: 'blind', name: 'osoba niewidoma' },
  { value: 'hearing_impaired', name: 'osoba niedosłysząca' },
  { value: 'deaf', name: 'osoba Głucha' },
  { value: 'eldery', name: 'osoba starsza' },
  { value: 'other', name: 'inny (opisz w uwagach)' }
]

const equipmentTypes = [
  { value: 'maunal_wheelchair', name: 'wózek manualny', for: ['wheelchair'] },
  {
    value: 'electric_wheelchair',
    name: 'wózek elektryczny',
    for: ['wheelchair']
  },
  { value: 'crutches', name: 'kule', for: ['walk_diffuculty', 'eldery'] },
  {
    value: 'walker',
    name: 'balkonik/chodzik',
    for: ['walk_diffuculty', 'eldery']
  },
  {
    value: 'stroller',
    name: 'wózek dziecięcy',
    for: ['walk_diffuculty', 'wheelchair']
  },
  {
    value: 'special_stroller',
    name: 'wózek dziecięcy specjalistyczny',
    for: ['walk_diffuculty', 'wheelchair']
  },
  { value: 'cane', name: 'laska', for: ['eldery'] },
  { value: 'white_cane', name: 'biała laska', for: ['blind'] },
  { value: 'other', name: 'inny (opisz w uwagach)' },
  {
    value: 'na',
    name: 'nie dotyczy',
    for: ['eldery', 'visually_impaired', 'blind', 'deaf', 'hearing_impaired']
  }
]

const sizeTypes = [
  { value: 0, name: 'przekracza' },
  { value: 1, name: 'nie przekracza' }
]

const carrierTypes = [
  'PKP INTERCITY S.A.',
  'Arriva RP sp. z o.o.',
  'Koleje Dolnośląskie S.A.',
  '"Koleje Mazowieckie - KM" sp. z o.o.',
  'Koleje Małopolskie sp. z o.o.',
  'Koleje Śląskie sp. z o.o.',
  'Koleje Wielkopolskie sp. z o.o.',
  'Łódzka Kolej Aglomeracyjna sp. z o.o.',
  'POLREGIO sp. z o.o.',
  'PKP Szybka Kolej Miejska w Trójmieście sp. z o.o.',
  'Szybka Kolej Miejska w Warszawie sp. z o.o.',
  'Warszawska Kolej Dojazdowa sp. z o.o.',
  'Inni przewoźnicy'
  // 'Połączenie międzynarodowe',
  // 'Inny (szczegóły w uwagach)',
]

const assistanceAtStationTypes = [
  // {value: 'both', name: 'na stacjach wsiadania i wysiadania'},
  { value: 'departure', name: 'na stacji wsiadania' },
  { value: 'arrival', name: 'na stacji wysiadania' },
  { value: 'transfer', name: 'na stacji przesiadania się' },
  { value: 'na', name: 'nie potrzebuję pomocy' }
]

const assistanceInTrainTypes = [
  // {value: 'in_out', name: 'przy wsiadaniu i wysiadaniu'},
  { value: 'in', name: 'przy wsiadaniu' },
  { value: 'out', name: 'przy wysiadaniu' },
  { value: 'seat', name: 'wskazanie miejsca w pociągu i pomoc w jego zajęciu' },
  { value: 'na', name: 'nie potrzebuję pomocy' }
]

const assistanceBaggageTypes = [
  { value: 'at_station', name: 'pomoc w przeniesieniu w obrębie dworca' },
  {
    value: 'in_out_train',
    name: 'pomoc przy wniesieniu i wyniesieniu do/z pociągu'
  },
  { value: 'at_seat', name: 'pomoc w lokowaniu' },
  { value: 'na', name: 'nie potrzebuję pomocy' }
]

const formTypes = [
  { value: 'individual', name: 'indywidualnie' },
  { value: 'group', name: 'w ramach oferty Bilet grupowy' }
]

const formTypesRadio = [
  { value: 'individual', id: 'individual', name: 'indywidualnie' },
  { value: 'group', id: 'group', name: 'w ramach oferty Bilet grupowy' }
]

const participantTypes = [
  { value: 'carer', name: 'opiekun/przewodnik' },
  // {value: 'guide', name: 'przewodnik'},
  // {value: 'dog', name: 'pies przewodnik'},
  { value: 'assisting_dog', name: 'pies asystujący/pies przewodnik' },
  // {value: 'other', name: 'inne osoby'},
  { value: 'na', name: 'podróżuję samodzielnie' }
]

const replyTypes = [
  { value: 'phone', name: 'telefon' },
  // { value: 'email', name: 'email' },
  // {value: 'voice_mail', name: 'poczta głosowa'},
  { value: 'sms', name: 'wiadomość tekstowa (sms)' }
]

const meetingPlaceTypes = [
  { value: 'platform', name: 'peron' },
  { value: 'prm', name: 'miejsce wyznaczone do spotkania OzN' },
  // {value: 'cash_1', name: 'przy kasie'},
  { value: 'other', name: 'inne' }
]

export {
  disabilityTypes,
  equipmentTypes,
  sizeTypes,
  carrierTypes,
  assistanceAtStationTypes,
  assistanceInTrainTypes,
  assistanceBaggageTypes,
  formTypes,
  participantTypes,
  replyTypes,
  meetingPlaceTypes
}
